import {
  PriceAlert,
  PriceAlertPoolResponse,
  PriceAlertQuarantineHistoryResponse,
  PriceAlertQuarantineResponse,
  PriceAlertsResponse,
  PriceHistory,
  PriceSummary,
  RetailerPriceHistory,
} from '@/types/priceAlert'
import { defineStore } from 'pinia'

interface States {
  priceSummary: Ref<PriceSummary | null>
  priceHistory: Ref<PriceHistory[] | null>
  priceAlerts: Ref<PriceAlertsResponse | null>
  priceAlert: Ref<PriceAlert | null>
  priceAlertPools: Ref<
    {
      alertId: number
      response: PriceAlertPoolResponse
    }[]
  >
  retailerProductPriceSummary: Ref<PriceSummary | null>
  retailerProductPriceHistory: Ref<RetailerPriceHistory[] | null>
  quarantinedRetailers: Ref<PriceAlertQuarantineResponse | null>
  quarantineHistory: Ref<PriceAlertQuarantineHistoryResponse | null>
}

export const usePriceAlertStore = defineStore('priceAlert', () => {
  const states: States = {
    priceSummary: ref(null),
    priceHistory: ref(null),
    priceAlerts: ref(null),
    priceAlert: ref(null),
    priceAlertPools: ref([]),
    retailerProductPriceSummary: ref(null),
    retailerProductPriceHistory: ref(null),
    quarantinedRetailers: ref(null),
    quarantineHistory: ref(null),
  }

  const resetStore = () => {
    states.priceSummary.value = null
  }

  return {
    ...states,
    resetStore,
  }
})
